import gpic1 from "../images/gpic1.jpeg";
import gpic2 from "../images/gpic2.jpeg";
import gpic3 from "../images/gpic3.jpeg";
import gpic4 from "../images/gpic4.jpeg";
import gpic5 from "../images/gpic5.jpeg";
import gpic6 from "../images/gpic6.jpeg";
import gpic7 from "../images/gpic7.jpeg";
import gpic8 from "../images/gpic8.jpeg";
import gpic9 from "../images/gpic9.jpeg";
import gpic10 from "../images/gpic10.jpeg";
import gpic11 from "../images/gpic11.jpeg";
import gpic12 from "../images/gpic12.jpeg";
import gpic13 from "../images/gpic13.jpeg";
import gpic14 from "../images/gpic14.jpeg";
import gpic15 from "../images/gpic15.jpeg";
import gpic16 from "../images/gpic16.jpeg";
import gpic17 from "../images/gpic17.png";
import gpic18 from "../images/gpic18.png";
import gpic19 from "../images/gpic19.png";
import gpic20 from "../images/gpic20.png";
import gpic21 from "../images/gpic21.png";
import gpic22 from "../images/gpic22.png";
import gpic23 from "../images/gpic23.png";
import gpic24 from "../images/gpic24.png";
import gpic25 from "../images/gpic25.png";
import gpic26 from "../images/gpic26.png";
import gpic27 from "../images/gpic27.png";
import gpic28 from "../images/gpic28.png";
import gpic29 from "../images/gpic29.png";
import gpic30 from "../images/gpic30.png";
import gpic31 from "../images/gpic31.png";
import gpic32 from "../images/gpic32.png";
import gpic33 from "../images/gpic33.png";
import gpic34 from "../images/gpic34.png";
import gpic35 from "../images/gpic35.jpeg"
import gpic36 from "../images/gpic36.jpeg"
import gpic37 from "../images/gpic37.jpeg"

const galleries = [
    {
        "id": 1,
        // "title": "Women’s Retreat",
        "image": gpic35
    },
    {
        "id": 2,
        // "title": "Faith and Wellness Workshop",
        "image": gpic36
    },
    {
        "id": 3,
        // "title": "Charity Fundraiser Gala",
        "image": gpic37
    },

    {
        "id": 1,
        // "title": "Women’s Retreat",
        "image": gpic1
    },
    {
        "id": 2,
        // "title": "Faith and Wellness Workshop",
        "image": gpic2
    },
    {
        "id": 3,
        // "title": "Charity Fundraiser Gala",
        "image": gpic3
    },
    {
        "id": 4,
        // "title": "Youth Mentorship Program",
        "image": gpic4
    },
    {
        "id": 5,
        // "title": "Bible Study Group",
        "image": gpic5
    },
    {
        "id": 6,
        // "title": "Community Outreach",
        "image": gpic6
    },
    {
        "id": 7,
        // "title": "Prayer Breakfast",
        "image": gpic7
    },
    {
        "id": 8,
        // "title": "Holiday Celebration",
        "image": gpic8
    },
    {
        "id": 9,
        // "title": "Volunteer Appreciation Night",
        "image": gpic9
    },
    {
        "id": 10,
        // "title": "Mother’s Day Luncheon",
        "image": gpic10
    },
    {
        "id": 11,
        // "title": "Christmas Caroling",
        "image": gpic11
    },
    {
        "id": 12,
        // "title": "Leadership Training Seminar",
        "image": gpic12
    },
    {
        "id": 13,
        // "title": "Bishop Taiwo Kuku & Pastor Sade Kuku",
        "image": gpic13
    },
    {
        "id": 14,
        // "title": "Book Club Meeting",
        "image": gpic14
    },
    {
        "id": 15,
        // "title": "Bishop Taiwo Kuku & Pastor Sade Kuku",
        "image": gpic15
    },
    {
        "id": 16,
        // "title": "Women’s Conference",
        "image": gpic16
    },
    {
        "id": 17,
        // "title": "Free Health Screening",
        "image": gpic17
    },
    {
        "id": 18,
        // "title": "Free Health Screening",
        "image": gpic18
    },
    {
        "id": 19,
        // "title": "Free Health Screening",
        "image": gpic19
    },
    {
        "id": 20,
        // "title": "Thanksgiving Dinner",
        "image": gpic20
    },
    {
        "id": 21,
        // "title": "Easter Egg Hunt",
        "image": gpic21
    },
    {
        "id": 22,
        // "title": "Free Health Screening",
        "image": gpic22
    },
    {
        "id": 23,
        // "title": "Free Health Screening",
        "image": gpic23
    },
    {
        "id": 24,
        // "title": "Free Health Screening",
        "image": gpic24
    },
    {
        "id": 25,
        // "title": "Free Health Screening",
        "image": gpic25
    },
    {
        "id": 26,
        // "title": "New Year’s Eve Service",
        "image": gpic26
    },
    {
        "id": 27,
        // "title": "Back-to-School Bash",
        "image": gpic27
    },
    {
        "id": 28,
        // "title": "Father’s Day Celebration",
        "image": gpic28
    },
    {
        "id": 29,
        // "title": "Lenten Reflections",
        "image": gpic29
    },
    {
        "id": 30,
        // "title": "Bishop Taiwo Kuku & Pastor Sade Kuku",
        "image": gpic30
    },
    {
        "id": 31,
        // "title": "Choir Concert",
        "image": gpic31
    },
    {
        "id": 32,
        // "title": "Advent Prayer Service",
        "image": gpic32
    },
    {
        "id": 33,
        // "title": "Soup Kitchen Volunteer Day",
        "image": gpic33
    },
    {
        "id": 34,
        // "title": "Mission Trip",
        "image": gpic34
    }
];

export default galleries
